import MessageBox from '../userMessages/messageBox';

const ConfirmSummary = ({
  changes,
  describeHeater = (partNumber) => partNumber,
  onConfirm,
  onCancel,
}) => {
  const messages = [
    ...changes.toAdd.map((partNumber) => `add ${describeHeater(partNumber)}`),
    ...changes.toDelete.map(
      (partNumber) => `remove ${describeHeater(partNumber)}`,
    ),
  ];

  return (
    <MessageBox
      title='confirm heater changes'
      messages={messages}
      actions={[
        { name: 'cancel', onClick: onCancel },
        { name: 'confirm', onClick: onConfirm },
      ]}
    />
  );
};

export default ConfirmSummary;
